import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { ViewTransition } from 'react';
import type { CardProps } from '@mui/material/Card';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
export type MediaCardProps = Omit<CardProps, 'title'> & {
  image?: React.ReactNode;
  title?: React.ReactNode;
  actions?: React.ReactNode;
  transitionName?: string;
};
export default function MediaCard(t0) {
  const $ = _c(25);
  let actions;
  let children;
  let image;
  let props;
  let sx;
  let title;
  let transitionName;
  if ($[0] !== t0) {
    ({
      image,
      title,
      children,
      sx,
      actions,
      transitionName,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = actions;
    $[2] = children;
    $[3] = image;
    $[4] = props;
    $[5] = sx;
    $[6] = title;
    $[7] = transitionName;
  } else {
    actions = $[1];
    children = $[2];
    image = $[3];
    props = $[4];
    sx = $[5];
    title = $[6];
    transitionName = $[7];
  }
  let t1;
  if ($[8] !== image) {
    t1 = image ? <CardMedia sx={{
      height: "280px",
      "& img": {
        width: "100%",
        height: "100%",
        objectFit: "cover"
      }
    }}>{image}</CardMedia> : null;
    $[8] = image;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const carMedia = t1;
  let t2;
  if ($[10] !== carMedia || $[11] !== transitionName) {
    t2 = carMedia ? transitionName ? <ViewTransition name={transitionName}>{carMedia}</ViewTransition> : carMedia : null;
    $[10] = carMedia;
    $[11] = transitionName;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      WebkitLineClamp: 1,
      textOverflow: "ellipsis",
      height: "32px"
    };
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== title) {
    t4 = <Typography gutterBottom={true} variant="h5" component="div" color="primary" sx={t3}>{title}</Typography>;
    $[14] = title;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== children || $[17] !== t4) {
    t5 = <CardContent>{t4}{children}</CardContent>;
    $[16] = children;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  const t6 = actions ? actions : null;
  let t7;
  if ($[19] !== props || $[20] !== sx || $[21] !== t2 || $[22] !== t5 || $[23] !== t6) {
    t7 = <Card sx={sx} {...props}>{t2}{t5}{t6}</Card>;
    $[19] = props;
    $[20] = sx;
    $[21] = t2;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
}